module.exports = __webpack_public_path__ + "static/media/non-binary.ff9d0bac.svg";